import { SelectBox } from "@monolith-forensics/monolith-ui";
import { ASSET_TYPE_IDS } from "../labAssets.constants";
import { LAB_ASSET_TYPE_LABELS } from "../labAssets.utils";

const ALL = "all";

// "All" stores no type_ids, which applies the field to every asset type.
const assetTypeOptions = [
  { label: "All", value: ALL },
  {
    label: LAB_ASSET_TYPE_LABELS.equipment,
    value: ASSET_TYPE_IDS.equipment,
  },
  { label: LAB_ASSET_TYPE_LABELS.software, value: ASSET_TYPE_IDS.software },
];

interface AssetTypeSelectBoxProps {
  defaultValue?: number[];
  onChange: (typeIds: number[]) => void;
  // The type is fixed once a field exists (values on the other type would
  // otherwise be orphaned), so the edit modal renders this read-only.
  disabled?: boolean;
}

// Custom field settings' Associated Types input for asset fields: a field
// applies to one type or both, so a single select stands in for the
// evidence-style tag box while still writing type_ids.
export const AssetTypeSelectBox = ({
  defaultValue,
  onChange,
  disabled = false,
}: AssetTypeSelectBoxProps) => (
  <SelectBox
    label="Associated Types"
    description={
      disabled
        ? "Set when the field was created"
        : "Limit this field to an asset type"
    }
    data={assetTypeOptions}
    disabled={disabled}
    defaultValue={defaultValue?.length === 1 ? defaultValue[0] : ALL}
    onChange={(value: number | typeof ALL) =>
      onChange(value === ALL ? [] : [value])
    }
  />
);
